module.exports = __webpack_public_path__ + "img/Finland.5fb32065.svg";